<!-- Let ngx-charts size itself to avoid resize-driven redraws. -->
@if (legend && legendItems.length) {
  <div class="chart-legend-top">
    @for (item of legendItems; track item.name) {
      @if (toggleableLegend) {
        <label
          class="chart-legend-item chart-legend-toggle"
          [class.is-hidden]="!item.enabled"
          [style.--legend-color]="item.color">
          <input
            type="checkbox"
            [checked]="item.enabled"
            (change)="toggleSeries(item.key)">
          <span>{{ item.name }}</span>
        </label>
      } @else {
        <span class="chart-legend-item">
          <i class="chart-legend-swatch" [style.background]="item.color"></i>
          {{ item.name }}
        </span>
      }
    }
  </div>
}
<div class="chart-container" [style.height.px]="height">
@switch (chartType) {
  @case ('line') {
    <ngx-charts-line-chart
      [results]="displayedData"
      [xAxis]="chartConfig.XAxis"
      [xAxisTickFormatting]="xAxisTickFormatting"
      [yAxis]="chartConfig.YAxis"
      [autoScale]="chartConfig.autoScale"
      [showGridLines]="chartConfig.showGridLines"
      [scheme]="lineChartScheme"
      [animations]="chartConfig.animations">
    </ngx-charts-line-chart>
  }
  @case ('bar-grouped') {
    <ngx-charts-bar-vertical-2d
      [results]="displayedData"
      [xAxis]="chartConfig.XAxis"
      [xAxisTickFormatting]="xAxisTickFormatting"
      [yAxis]="chartConfig.YAxis"
      [showGridLines]="chartConfig.showGridLines"
      [scheme]="barChartScheme"
      [animations]="chartConfig.animations"
      [roundEdges]="chartConfig.roundEdges"
      [barPadding]="chartConfig.barPadding">
    </ngx-charts-bar-vertical-2d>
  }
  @case ('bar-stacked') {
    <ngx-charts-bar-vertical-stacked
      [results]="displayedData"
      [xAxis]="chartConfig.XAxis"
      [xAxisTickFormatting]="xAxisTickFormatting"
      [yAxis]="chartConfig.YAxis"
      [showGridLines]="chartConfig.showGridLines"
      [scheme]="displayedScheme"
      [animations]="chartConfig.animations"
      [barPadding]="chartConfig.barPadding"
      [legend]="false">
    </ngx-charts-bar-vertical-stacked>
  }
}
</div>
